import styled from 'vue-styled-components'

const btnProps = { active: Boolean }
const btn = styled('button', btnProps)`
    background: ${props => props.active ? '#009dd8' : '#f7f7f7'};
    color: ${props => props.active ? '#fff' : '#444'};
    border: 1px solid rgba(0,0,0,.2);
    border-bottom-color: rgba(0,0,0,.3);
    background-origin: border-box;
    background-image: ${props => props.active ? 'linear-gradient(to bottom,#00b4f5,#008dc5)' : 'linear-gradient(to bottom,#fff,#eee)'};
    text-shadow: 0 1px 0 #fff;
    cursor: ${props => props.active ? 'default' : 'pointer'};
    display: inline-block;
    min-width: 16px;
    padding: 3px 5px;
    line-height: 20px;
    text-decoration: none;
    text-align: center;
    border-radius: 4px;
    margin-right: 5px;
    &:hover {
        background-color: ${props => props.active ? '#009dd8' : '#fafafa;'};
        color: ${props => props.active ? '$fff' : '#444'};
        outline: 0;
        background-image: ${props => props.active ? 'linear-gradient(to bottom,#00b4f5,#008dc5)' : 'none'};
    }
`

export default btn